import type {
  AutoConfiguratorState,
  QuantityBreak,
  QuantityBreakValueId,
  Value,
} from '@snap-types/models/auto-configurator/state';

import { getLineItem } from './line-item';

export function getQuantityBreak(
  state: AutoConfiguratorState,
  quantityBreakUuid: string,
): QuantityBreak {
  const quantityBreak = state.quantityBreaks[quantityBreakUuid];

  if (!quantityBreak) {
    throw new Error(
      `Quantity break not found with UUID: "${quantityBreakUuid}"`,
    );
  }

  return quantityBreak;
}

export function getQuantityBreakFromValueId(
  state: AutoConfiguratorState,
  valueId: QuantityBreakValueId,
): QuantityBreak {
  return getQuantityBreak(state, valueId.uuid);
}

export function getFirstQuantityBreak(
  state: AutoConfiguratorState,
  lineItemUuid: string,
): QuantityBreak {
  const lineItem = getLineItem(state, lineItemUuid);
  const uuid = lineItem.quantityBreakUuids[0];

  if (!uuid) {
    throw new Error(
      `Expected line item "${lineItemUuid}" to have at least one quantity break`,
    );
  }

  return getQuantityBreak(state, uuid);
}

export function getLastQuantityBreak(
  state: AutoConfiguratorState,
  lineItemUuid: string,
): QuantityBreak {
  const lineItem = getLineItem(state, lineItemUuid);
  const uuid = lineItem.quantityBreakUuids.at(-1)!;

  return getQuantityBreak(state, uuid);
}

export function getQuantityBreakValue(
  state: AutoConfiguratorState,
  valueId: QuantityBreakValueId,
): Value {
  const { uuid, key } = valueId;

  const quantityBreak = getQuantityBreak(state, uuid);

  return quantityBreak[key];
}
